import { useSelector } from 'react-redux';

import {
  selectEtazhiBlackFridayIsEnabledByRegion,
  selectEtazhiBlackFridayPromoOffersData,
} from 'shared/selectors/etazhiBlackFriday';
import { getIsStartDatePassed } from 'shared/utils/etazhiBlackFriday';

export function usePromoOffersVisibility() {
  const isEnabledByRegion = useSelector(selectEtazhiBlackFridayIsEnabledByRegion);
  const promoOffersData = useSelector(selectEtazhiBlackFridayPromoOffersData);
  const isPromoOffersEnabled = !!promoOffersData?.enabled;
  const isStartDatePassed = getIsStartDatePassed(promoOffersData);

  return isEnabledByRegion && isPromoOffersEnabled && isStartDatePassed;
}
